import $ from "jquery";
import 'bootstrap-icons/font/bootstrap-icons.css';
var dataTable;
$(function () {
    var currentPage = $("#currentPage").val();
    if (currentPage != "productView")
        return;
});
function initlightbox() {
    // Inicializácia Isotope    
    var currentIndex = 0;
    var $galleryItems = $(".gallery-item");
    var $lightbox = $("#lightbox");
    var $lightboxImg = $("#lightbox-img");
    var $closeButton = $("#close");
    var $prevButton = $("#prev");
    var $nextButton = $("#next");
    // Otvorenie lightboxu
    $galleryItems.on("click", function () {
        currentIndex = $galleryItems.index(this);
        updateLightbox();
        $lightbox.fadeIn(300);
    });
    // Zatvorenie lightboxu
    $closeButton.on("click", function () {
        $lightbox.fadeOut(300);
    });
    // Navigácia medzi obrázkami
    var updateLightbox = function () {
        var newSrc = $galleryItems.eq(currentIndex).attr("src");
        $lightboxImg.attr("src", newSrc);
    };
    $prevButton.on("click", function () {
        currentIndex = (currentIndex - 1 + $galleryItems.length) % $galleryItems.length;
        updateLightbox();
    });
    $nextButton.on("click", function () {
        currentIndex = (currentIndex + 1) % $galleryItems.length;
        updateLightbox();
    });
    // Zatvorenie kliknutím mimo obrázka
    $lightbox.on("click", function (event) {
        if ($(event.target).is("#lightbox")) {
            $lightbox.fadeOut(300);
        }
    });
}
//# sourceMappingURL=productView.js.map